// extracted by mini-css-extract-plugin
export default {"tapeBody":"dark_tapeBody__pTx6y color_colorDarkBorder__4I8G6","overflow":"dark_overflow__OQRV5 color_colorDarkBorder__4I8G6 color_colorDarkBackground__VTGL5"};